// These are used to determine what is considered a User vs System namespace in the namespace picker,
// along with the `isSystem` property of the project associated with the namespace, if in Rancher mode.
export default [
  'cattle-dashboards',
  'cattle-global-data',
  'cattle-system',
  'gatekeeper-system',
  'ingress-nginx',
  'kube-node-lease',
  'kube-public',
  'kube-system',
  'linkerd',
  'security-scan',
  'tekton-pipelines',
  'compliance-operator-system',
  'istio-system',
  'k3k-system',
  'longhorn-system',
];
